import * as React from 'react';

import * as styles from './styles.css';
import { TCustomAction } from '../../../types/customActions';

export enum EUserCardMenuItemType {
  Archive = 'archive',
}

export type TUserCardMenuItem = {
  title: React.JSX.Element;
  handler(currentChatId: string): void;
  type: EUserCardMenuItemType | TCustomAction;
};

type TUserCardMenuContent = {
  currentChatId: string;
  menuItems: TUserCardMenuItem[];
};

export const UserCardMenuContent: React.FC<TUserCardMenuContent> = ({ currentChatId, menuItems }) => {
  const items = React.useMemo(
    () =>
      menuItems.map(({ title, handler }, index) => (
        <li
          key={index}
          data-testid="UserCardMenuItem"
          className={styles['item']}
          onClick={() => {
            handler(currentChatId);
          }}
        >
          {title}
        </li>
      )),
    [currentChatId, menuItems],
  );

  return (
    <ul className={styles['menu']} data-testid="UserCardMenuContent">
      {items}
    </ul>
  );
};
